<template>
  <slot></slot>
  <Toast />
</template>

<script setup lang="ts">
import { provide } from 'vue';
import Toast from '@/components/Toast/Index.vue';
import { useToastStore } from '@/stores/toast.store';
import type { IToastState } from '@/types/toasts';

// Provide a global 'toast' API for components that use inject('toast')
const toastStore = useToastStore();

type ToastConfigs = Partial<IToastState['configs']>;

const toast = {
  show: (
    message: string,
    type: 'success' | 'error' | 'info' | 'warning' = 'info',
    configs?: ToastConfigs,
  ) => {
    toastStore.showToast(message, type, configs);
  },
  success: (message: string, configs?: ToastConfigs) =>
    toastStore.showToast(message, 'success', configs),
  error: (message: string, configs?: ToastConfigs) =>
    toastStore.showToast(message, 'error', configs),
  info: (message: string, configs?: ToastConfigs) => toastStore.showToast(message, 'info', configs),
  warning: (message: string, configs?: ToastConfigs) =>
    toastStore.showToast(message, 'warning', configs),
  hide: () => toastStore.hideToast(),
};

provide('toast', toast);
</script>
